import React, { Fragment } from 'react';
import {
  translate,
  Datagrid,
  Edit,
  Create,
  EditButton,
  List,
  SimpleForm,
  TextField,
  TextInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  BulkDeleteButton,
  NumberInput,
  DateField,
  CreateButton,
  ExportButton,
} from 'react-admin';
import DateInput from '../../../../components/DateInput';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';

import LinkToList from './LinkToList';
import remarkP from '../remarkP';
import SendRemarkButton from './SendRemarkButton';
import resourceLocales from './locales';
import resourceConfig from './config';
import documentRowStyle from '../../../../utils/ui/documentRowStyle';
import errorModel from '../errorModel';
import objectSendModel from '../objectSendModel';
import directionType from '../directionType';
import docStatus from '../docStatus';
import docLinkType from '../docLinkType';
import docStatusSystem from '../docStatusSystem';
import markingType from '../markingType';
import remarkCause from '../remarkCause';
import docLink from '../docLink';
import exporter from '../../../../utils/exporter';
import docUpdate from '../docUpdate';
import docCheckStatus from '../docCheckStatus';
import documentImport from '../documentImport';
import Toolbar from '@material-ui/core/Toolbar';
import PostPagination from '../../../../utils/pagination';
import ExportDocButton from '../docH/ExportDocButton';
const ResourceIcon = BookmarkIcon;

const listStyles = {};

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <documentImport.OpenButton params={{ docType: 'REMARK' }} />
    <CreateButton basePath={basePath} to={`${basePath}/create`} />
    <ExportDocButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const ResourceBulkActionButtons = (props) => (
  <Fragment>
    <docUpdate.Button {...props} bulk docType={'REMARK'} />
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <TextInput source={'ids'} />
    <TextInput source={'guids'} />
    <TextInput source={'docnums'} />
  </Filter>
);

const ChildrenPButton = (props) => {
  return (
    <remarkP.LinkToList
      label={`resources.${resourceConfig.name}.remarkP`}
      filter={{
        overEntityIds: props.record.id,
      }}
    />
  );
};

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    bulkActionButtons={<ResourceBulkActionButtons />}
    actions={<ResourceActions />}
    exporter={exporter}
    pagination={<PostPagination />}>
    <Datagrid rowStyle={documentRowStyle}>
      <TextField source={'id'} />

      <markingType.Field source={'markingType'} />
      <remarkCause.Field source={'remarkingCause'} />
      <DateField source={'remarkingDate'} />

      <TextField source={'guid'} />
      <docCheckStatus.Field source={'checkStatus'} />

      <docLink.Field />

      <errorModel.LinkToRelatedList type={'REMARK'} />
      <objectSendModel.LinkToRelatedList type={'REMARK'} />
      <SendRemarkButton />
      <ChildrenPButton />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.name}
    &quot;
  </span>
));

const ResourceCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source={'actionId'} />
      {/* <TextInput source={'companyUniqName'} /> */}
      {/* <TextInput source={'creatorUsername'} /> */}
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      <NumberInput source={'documentLinkId'} />
      <docLinkType.Input source={'documentLinkType'} />
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <errorModel.Input source={'errorModelId'} />
      <markingType.Input source={'markingType'} />
      <TextInput source={'participantInn'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'receiverId'} />
      <remarkCause.Input source={'remarkingCause'} />
      <DateInput
        source={'remarkingDate'}
        label={`resources.${resourceConfig.name}.fields.remarkingDate`}
      />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
    </SimpleForm>
  </Create>
);

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm redirect={false}>
      <TextField source={'id'} />
      <TextInput source={'actionId'} />
      {/* <TextInput source={'companyUniqName'} /> */}
      {/* <TextInput source={'creatorUsername'} /> */}
      <directionType.Input source={'direction'} />
      <docStatus.Input source={'docStatus'} />
      <TextInput source={'docnum'} />
      <TextInput source={'documentId'} />
      <NumberInput source={'documentLinkId'} />
      <docLinkType.Input source={'documentLinkType'} />
      <docStatusSystem.Input source={'documentSystemStatus'} />
      <errorModel.Input source={'errorModelId'} />
      <markingType.Input source={'markingType'} />
      <TextInput source={'participantInn'} />
      <DateInput
        source={'processedDate'}
        label={`resources.${resourceConfig.name}.fields.processedDate`}
      />
      <TextInput source={'receiverId'} />
      <remarkCause.Input source={'remarkingCause'} />
      <DateInput
        source={'remarkingDate'}
        label={`resources.${resourceConfig.name}.fields.remarkingDate`}
      />
      <TextInput source={'requestId'} />
      <TextInput source={'subjectId'} />
    </SimpleForm>
  </Edit>
);

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Create: ResourceCreate,
  Edit: ResourceEdit,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    edit: ResourceEdit,
    create: ResourceCreate,
    icon: ResourceIcon,
  },
  menuConfig: {
    name: resourceConfig.name,
    icon: ResourceIcon,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {
      processedDate: {
        type: 'dateTime',
      },
      remarkingDate: {
        type: 'dateTime',
      },
    },
    filters: {
      processedDate: {
        type: 'dateTime',
      },
      remarkingDate: {
        type: 'dateTime',
      },
    },
  },
};
